<template>
  <v-container
    fluid
    class="fill-height d-flex flex-row align-center"
    style="background-color: rgba(255, 255, 255, 0.65)"
  >
    <v-row>
      <v-col md="4" sm="12" offset-md="4">
        <v-card class="pa-5">
          <logo class="my-5" />
          <v-card-title class="text-h5 d-flex flex-row justify-center">
            Login
          </v-card-title>

          <v-card-text class="text-justify mt-4 pb-0">
            <v-alert
              outlined
              v-if="$store.getters['Auth/alert'].status"
              dense
              border="left"
              :type="
                $store.getters['Auth/alert'].status === 'success'
                  ? 'success'
                  : 'error'
              "
              class="mb-10"
            >
              {{ $store.getters["Auth/alert"].message }}
            </v-alert>

            <v-text-field
              dense
              outlined
              label="Email Address"
              placeholder="Enter your Email Address"
              v-model="formData.email"
              ref="email"
              :rules="rules.email"
            />

            <v-text-field
              dense
              outlined
              label="Password"
              placeholder="Enter your password"
              type="password"
              v-model="formData.password"
              ref="password"
              :rules="rules.password"
            />
          </v-card-text>

          <v-card-actions class="mt-3">
            <v-btn small text :to="{ name: 'forgotPassword' }">
              Forgot password?
            </v-btn>

            <v-spacer />
            <v-btn @click="login" color="primary">
              &nbsp;&nbsp;&nbsp; Login
              <v-icon right> mdi-arrow-right </v-icon>
              &nbsp;&nbsp;&nbsp;
            </v-btn>
          </v-card-actions>

          <v-divider />

          <p class="caption text-center mt-10">First time here ?</p>

          <v-card-actions>
            <v-btn
              small
              text
              block
              color="secondary"
              :to="{ name: 'activate' }"
            >
              Activate account
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RouterMixin from "@/mixins/RouterMixin";
import Logo from "@/components/appLogo";

export default {
  name: "appLogin",
  components: { Logo },
  mixins: [RouterMixin],
  data: function () {
    return {
      formData: {
        email: "",
        password: "",
      },
      isGrant: process.env.VUE_APP_GRANT_REVIEW_PORTAL,
    };
  },

  computed: {
    rules() {
      return {
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        password: [(v) => !!v || "Password is required"],
      };
    },
  },

  methods: {
    login: function () {
      let isValid = true;
      for (const key in this.formData) {
        if (this.$refs[key])
          isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid)
        this.$store.dispatch("Auth/login", {
          ...this.formData,
          ...{ isGrant: this.isGrant },
        });
    },
  },
};
</script>

<style scoped></style>
